"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultOptions = void 0;
var deepmerge_1 = __importDefault(require("deepmerge"));
var common_translations_1 = require("../../common-translations");
var keys = {
    errorSectionTitle: 'errors.errorSectionTitle',
    errorSectionBody: 'errors.errorSectionBody',
};
var defaultTranslations = (0, deepmerge_1.default)(common_translations_1.translations, {
    en: {
        errors: {
            errorSectionTitle: 'A problem has occurred',
            errorSectionBody: '<P>We’ll take a look at this shortly, in the meantime please try refreshing the page.</P>',
        },
    },
});
var defaultOptions = {
    keys: keys,
    defaultTranslations: defaultTranslations,
};
exports.defaultOptions = defaultOptions;
